export default __webpack_public_path__ + "static/media/home_girl3.d66bd647.jpg";